<div class="w-100 align-items-center justify-content-center d-flex flex-column flex-lg-row px-0 login-bg mt-0">
  <div class="m-auto d-flex justify-content-center flex-column flex-lg-row login align-items-center">
    <img class="logo mb-lg-5 mb-4" src="assets/images/Logos/RedbullsMemberPlusWhite.svg" />
    <div class="login-container mb-4 mb-lg-0">
      <div class="text-center mlb-text font-size-14" [innerHTML]="'login.info' | translate | markdownTranslate"></div>
      <fgb-sports-illustrated-user-login></fgb-sports-illustrated-user-login>
    </div>
  </div>
</div>
<div class="pb-5 pt-2">
  <fgbcl-preview />
</div>
